import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import { locale, loadMessages } from "devextreme/localization";
import ptMessages from "devextreme/localization/messages/pt.json";
import esMessages from "devextreme/localization/messages/es.json";
import deMessages from "devextreme/localization/messages/de.json";
import enMessages from "devextreme/localization/messages/en.json";

import translationES from "./locales/es-ES/translation.json";
import translationEN from "./locales/en-US/translation.json";
import translationPT from "./locales/pt-BR/translation.json";
import translationDE from "./locales/de-DE/translation.json";

loadMessages(ptMessages);
loadMessages(esMessages);
loadMessages(deMessages);
loadMessages(enMessages);

const resources = {
  'es-ES': {
    translation: translationES,
  },
  'en-US': {
    translation: translationEN,
  },
  'pt-BR': {
    translation: translationPT,
  },
  'de-DE': {
    translation: translationDE,
  }
};

i18n
    .use(initReactI18next)
    .use(Backend)
    .init({
        resources,
        fallbackLng: 'pt-BR',
        interpolation: {
            escapeValue: false,
        },
    });

const syncDevExtremeLocale = (lng) => {
  if (!lng) return;
  locale(lng);
};

syncDevExtremeLocale(i18n.language || "pt-BR");

i18n.on("languageChanged", (lng) => {
  syncDevExtremeLocale(lng);
});

export default i18n;
